import UtilsSerice from '../utils/utils.service';

const LicenseService = {
  init: async (): Promise<void> => {
    UtilsSerice.debugLog('License Service Init');
  },
};

export default LicenseService;
